/**
 * CinematicLayout - Global layout wrapper with the cinematic gold smoke theme
 * Applies the landing page style to all pages for visual consistency
 */

// Cinematic background image
const BACKGROUND_IMAGE = "https://customer-assets.emergentagent.com/job_4bcee762-f0d1-4c35-94f4-6a1ea05be5d8/artifacts/d7ksf7m9_IMG_3379.jpeg";

const CinematicLayout = ({ children, showLogo = false, className = "" }) => {
  return (
    <div className={`min-h-screen relative overflow-hidden ${className}`} style={{ background: '#000000' }}>
      {/* ===== CINEMATIC BACKGROUND IMAGE ===== */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${BACKGROUND_IMAGE})`,
          opacity: 0.85,
          zIndex: 0,
        }}
        aria-hidden="true"
      />
      
      {/* Dark gradient overlay for text readability */}
      <div 
        className="fixed inset-0"
        style={{
          background: 'radial-gradient(ellipse 60% 50% at 50% 50%, transparent 0%, rgba(0,0,0,0.5) 70%, rgba(0,0,0,0.8) 100%)',
          zIndex: 1,
        }}
        aria-hidden="true"
      />

      {/* Optional Big Logo Watermark */}
      {showLogo && (
        <div className="fixed inset-0 flex items-center justify-center pointer-events-none overflow-hidden" style={{ zIndex: 2 }}>
          <img
            src="/logo-reflection-trimmed.png"
            alt=""
            className="w-[150vw] max-w-none h-auto opacity-[0.06] select-none"
            style={{
              filter: 'blur(2px) drop-shadow(0 0 150px rgba(255, 150, 50, 0.5))',
              transform: 'scale(1.2)',
            }}
          />
        </div>
      )}

      {/* Main Content */}
      <div className="relative" style={{ zIndex: 10 }}>
        {children}
      </div>
    </div>
  );
};

export default CinematicLayout;
